import { post } from "./request";

export function timeLessGetInfo() {
    return post("/?service=myheroAnniversary2023&api=timeLessGetInfo")
}

export function timeLessGetTaskAward(taskId, cardType) {
    return post("/?service=myheroAnniversary2023&api=timeLessGetTaskAward", {
        "taskId": taskId,
        "cardType": cardType
    })
}

export function timeLessFinishTaptap() {
    return post("/?service=myheroAnniversary2023&api=timeLessFinishTaptap")
}

export function timeLessFillAddress(name, phone, address) {
    return post("/?service=myheroAnniversary2023&api=timeLessFillAddress", {
        "name": name,
        "phone": phone,
        "address": address
    })
}

export function timeLessGetAward() {
    return post("/?service=myheroAnniversary2023&api=timeLessGetAward")
}

export function timeLessGetLotteryAward() {
    return post("/?service=myheroAnniversary2023&api=timeLessGetLotteryAward")
}
    
export function timeLessGetExchangeToken(cardType) {
    return post("/?service=myheroAnniversary2023&api=timeLessGetExchangeToken", {
        "cardType": cardType
    })
}

export function timeLessExchangeCard(exchangeToken) {
    return post("/?service=myheroAnniversary2023&api=timeLessExchangeCard", {
        "exchangeToken": exchangeToken
    })
}

export function timeLessLottery() {
    return post("/?service=myheroAnniversary2023&api=timeLessLottery")
}